import axios from "axios";
import React, { useState, useEffect, useRef } from "react";
import { toast } from "react-toastify";
import { Box } from "@mui/material";
import { API_ENDPOINT, ONSITE_MODULE_ITEMS } from "../../utils/constants";
import { toastError } from "../../utils/util";
import { getOnsiteHeader } from "./utils";
import { EbadgeService } from "./EbadgeService";
export const getCategoryName = (userObj) => {
  const category = userObj.user_type
    ? userObj.user_type
    : "Pre-Registered Visitor";
  return category;
};

function ServiceBadgeScan() {
  const [currentUser, setCurrentUser] = useState();
  const inputRef = useRef();

  const handleScanInput = (event) => {
    if (event.key === "Enter") {
      event.preventDefault();
      const scannedValue = event.target.value;
      inputRef.current.value = "";
      loadUser(scannedValue);
    }
  };

  useEffect(() => {
    inputRef.current.focus();
  }, []);
  async function loadUser(id) {
    try {
      const response = await axios.get(
        `${API_ENDPOINT}/onsite/get-service-badge-barcode?id=${id}`,
        getOnsiteHeader(ONSITE_MODULE_ITEMS.SERVICE_BADGE_SCAN)
      );
      if (response.status === 200) {
        toast.success("Successfully Scanned!", { autoClose: 1 });
        setCurrentUser(response.data);
      } else if (response.status === 204) {
        // Handle successful response with no content
        toast.info("Invalid QR!", { autoClose: 1 });
      }
    } catch (error) {
      toastError(error);
    } finally {
    }
  }

  return (
    <Box>
      <Box
        sx={{
          flexGrow: 1, // This will make the box grow to fill available space
          display: "flex",
          flexDirection: "column",
          justifyContent: "flex-start",
        }}
      >
        <Box style={{ display: "block" }} ml={"auto"} mr={"auto"} mb={4}>
          <input
            ref={inputRef}
            id="barcodeInput"
            type="text"
            // value={barcodeId}
            // onChange={handleScanInput}
            onKeyDown={handleScanInput}
            placeholder="Scan Badge"
            style={{
              padding: "10px",
              fontSize: "16px",
              width: "300px",
              textAlign: "center",
              borderRadius: "4px",
              border: "2px solid #000",
            }}
          />
        </Box>
      </Box>
      <Box display={"flex"} justifyContent={"center"} alignContent={"center"}>
        {currentUser && (
          <Box display={"flex"} gap={4}>
            <Box>
              <img
                src={currentUser.photoUrl}
                style={{
                  display: "block",
                  height: "14cm",
                  width: "auto",
                  marginTop: "16px",
                }}
              />
            </Box>
            <EbadgeService isPreview={true} user={currentUser} />
          </Box>
        )}
      </Box>
    </Box>
  );
}

export default ServiceBadgeScan;
